import { Box } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';

export const ConversationSearchBarSkeleton = () => {
  return (
    <Box
      css={{
        borderBottom: '1px solid',
        borderBottomColor: 'border.subtle',
      }}
    >
      <Bone type="line" />
    </Box>
  );
};

export const LeadManagementConversationSearchBarSkeleton = () => {
  return (
    <Box
      css={{
        display: 'flex',
        flex: '0.4 0 0',
        alignItems: 'center',
        padding: 'default',
      }}
    >
      <Bone type="line" />
    </Box>
  );
};
